import React from 'react'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import Complaints from '../components/Complaints'
import ComplaintsMobile from '../components/ComplaintsMobile'
import Warning from '../components/Warning'
import Banner from "../components/Banner";

const ComplaintsPage = () => {
  return (
    <>
    <section className="hidden lg:block">
       <Banner />
    <Navbar />
    <Warning/>

  </section>
  <section className="block lg:hidden">
    <Sidebar />
  </section>
  <section >
    <Complaints />
  </section>
  {/* <section className="block lg:hidden">
    <ComplaintsMobile />
  </section> */}
  <Footer />

    </>
  )
}

export default ComplaintsPage